import {Button, Col, Flex, Row} from "antd";
import Typography from "antd/lib/typography";
import {
    competitionsStore,
    concourseGroupsStore,
    IConcourseGroup,
    IConcourseGroupsPriority,
    IConcourseGroupsPriorityProfile,
    ISpecialityProfile,
    resultStore
} from "../../../store/admissions/admissionStore";
import {useEffect, useState} from "react";
import {stepsStore} from "../../../store/admissions/stepperStore";
import {FaLongArrowAltDown, FaLongArrowAltUp} from "react-icons/fa";
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";
import {useLocation} from "react-router";

export default function Step3() {

    const {stepsData, setStepsData} = stepsStore();
    const location = useLocation();
    const {result, setResult} = resultStore();
    const {concourseGroups, setConcourseGroups} = concourseGroupsStore();
    const {competitions, setCompetitions} = competitionsStore();
    const [selectedGroups, setSelectedGroups] = useState<IConcourseGroup[]>([]);
    const {xl} = useBreakpoint()
    const [unique, setUnique] = useState<string[]>([]);
    const [uniqueProfiles, setUniqueProfiles] = useState<Map<string, string[]>>(new Map());

    useEffect(() => {
        const selectedConcourses =
            concourseGroups.filter(group => {
                return result.selectedConcourceGroupsCodes.includes(group.concourseGroupsCode)
            })

        setResult({
            ...result, concourseGroupsPriority: selectedConcourses.map((group, index) => (
                {
                    code: group.concourseGroupsCode,
                    priority: 0,
                    profiles: group.profiles?.map((profile, index: number) => (
                        {
                            profilecode: profile.code,
                            priority: index + 1
                        })),
                }))
        })

        setSelectedGroups(selectedConcourses)
        setStepsData({...stepsData, nextStep: false})
    }, []);

    const calculatePriority = (concourseGroup: IConcourseGroupsPriority, up: boolean) => {

        if (concourseGroup.priority <= 1 && !up) {
            return 1
        } else if (up) {
            if (concourseGroup.priority === result.concourseGroupsPriority.length) {
                return result.concourseGroupsPriority.length
            }
        }

        return up ? concourseGroup.priority + 1 : concourseGroup.priority - 1
    }

    const checkProfilesPriority = (concourseGroup: IConcourseGroup, newResult: IConcourseGroupsPriorityProfile[]) => {
        let found: string[] = [];
        newResult.forEach(profile => {
            const exists = newResult.filter(item => item.priority === profile.priority)
            if (exists.length > 1) {
                found.push(profile.profilecode)
            }
        })

        const newMap = uniqueProfiles
        if (found.length > 1) {
            newMap.set(concourseGroup.concourseGroupsCode, found)
            setUniqueProfiles(newMap)
            setStepsData({...stepsData, nextStep: false})
        } else {
            newMap.set(concourseGroup.concourseGroupsCode, [])
            setUniqueProfiles(newMap)
            setStepsData({...stepsData, nextStep: true})
        }
    }

    const checkGroupsPriority = (newResult: IConcourseGroupsPriority[]) => {
        let found: string[] = []
        newResult.forEach(group => {
            const exists = newResult.filter(founding => {
                if (founding.priority === group.priority && result.basistraining !== "платная") {
                    const groupData = concourseGroups.find(item => item.concourseGroupsCode === group.code)
                    const itemData = concourseGroups.find(item => item.concourseGroupsCode === founding.code)
                    if ((groupData?.specQualifier === itemData?.specQualifier) && (groupData?.concourseGroupsCode !== itemData?.concourseGroupsCode) && (groupData?.competitioncode !== itemData?.competitioncode)) {
                        if (groupData?.typecompetition === "Целевой прием" && itemData?.typecompetition !== "Целевой прием") {
                            return true
                        }
                        if (groupData?.typecompetition !== "Целевой прием" && itemData?.typecompetition === "Целевой прием") {
                            return true
                        }
                        return false
                    }
                }
                return founding.priority === group.priority
            })
            if (exists.length > 1) {
                found.push(group.code)
            }
        })

        if (found.length > 1) {
            setUnique([...found])
            setStepsData({...stepsData, nextStep: false})
        } else {
            setUnique([])
            if (!newResult.find(item => item.priority === 0)) {
                setStepsData({...stepsData, nextStep: true})
            }
        }
    }

    const getProfilePriorityText = (concourseGroup: IConcourseGroup, profile: ISpecialityProfile) => {
        return result.concourseGroupsPriority.find(group => group.code === concourseGroup.concourseGroupsCode)?.profiles?.find(profileItem => profileItem.profilecode === profile.code)?.priority
    }

    const calculateProfilePriority = (concourseGroup: IConcourseGroupsPriority, priorityProfile: IConcourseGroupsPriorityProfile, up: boolean) => {
        if (priorityProfile.priority === 1 && !up) {
            return 1
        } else if (up) {
            if (priorityProfile.priority === concourseGroup.profiles.length) {
                return concourseGroup.profiles.length
            }
        }

        return up ? priorityProfile.priority + 1 : priorityProfile.priority - 1
    }

    const groupingCheck = (concourseGroup: IConcourseGroup, group: IConcourseGroupsPriority) => {
        const founded = concourseGroups.find(item => item.concourseGroupsCode === group.code)
        if (concourseGroup.specQualifier === founded?.specQualifier && result.basistraining !== "платная" && (founded.competitioncode !== concourseGroup.competitioncode)) {
            if (founded.typecompetition === "Целевой прием" && concourseGroup.typecompetition === "Целевой прием") {
                return true
            }
            if (founded.typecompetition === "Целевой прием" && concourseGroup.typecompetition !== "Целевой прием") {
                return false
            }
            if (founded.typecompetition !== "Целевой прием" && concourseGroup.typecompetition === "Целевой прием") {
                return false
            }
            if (founded.typecompetition !== "Целевой прием" && concourseGroup.typecompetition !== "Целевой прием") {
                return true
            }
        } else {
            return group.code === concourseGroup.concourseGroupsCode
        }
    }

    const changePriority = (concourseGroup: IConcourseGroup, up: boolean) => {
        const newResult = result.concourseGroupsPriority.map(group => {
            const newPriority = calculatePriority(group, up)
            if (groupingCheck(concourseGroup, group)) {
                return {
                    ...group,
                    priority: newPriority
                }
            } else {
                return group
            }
        })
        setResult({
            ...result,
            concourseGroupsPriority: newResult
        })
        checkGroupsPriority(newResult)
    }

    const changeProfilePriority = (concourseGroup: IConcourseGroup, profile: ISpecialityProfile, up: boolean) => {
        setResult({
            ...result,
            concourseGroupsPriority: result.concourseGroupsPriority.map(group => {
                const newResult = group.profiles?.map((profileItem, index: number) => {
                    if (profileItem.profilecode === profile.code) {
                        return {
                            ...profileItem,
                            priority: calculateProfilePriority(group, profileItem, up)
                        }
                    } else {
                        return profileItem
                    }
                })
                if (group.code === concourseGroup.concourseGroupsCode) {
                    checkProfilesPriority(concourseGroup, newResult)
                }
                if (group.code === concourseGroup.concourseGroupsCode) {
                    return {
                        ...group,
                        profiles: newResult
                    }
                } else {
                    return group
                }

            })
        })
    }

    const ConcourseCard: React.FC<{ concourseGroup: IConcourseGroup, }> = ({concourseGroup}) => {
        return (
            <Flex className={xl ? "admission-speciality-card" : "admission-speciality-card-mobile"} vertical={true}
                  justify={"space-between"}>
                <Typography.Text style={{padding: "8px 16px", backgroundColor: "whitesmoke"}}
                                 strong>{concourseGroup.specQualifier} {concourseGroup.specName}</Typography.Text>
                <Flex style={{width: '100%', padding: "8px 16px 16px"}} justify={"space-between"}>
                    <Flex vertical={true}>
                        <Typography.Text>{`Уровень образования: ${concourseGroup.kindsLevelFormation.name};`}</Typography.Text>
                        <Typography.Text>{`Форма обучения: ${concourseGroup.kindsTraining.display};`}</Typography.Text>
                        <Typography.Text>{`Основа обучения: ${concourseGroup.basistraining};`}</Typography.Text>
                        <Typography.Text>{`Вид конкурса: ${competitions.find(item => item.value === concourseGroup.competitioncode)?.display};`}</Typography.Text>
                    </Flex>
                    <Flex vertical={true} justify={"center"} align={"flex-end"} gap={8}>
                        <Typography.Text>Приоритет</Typography.Text>
                        <Flex align={"center"} gap={8}>
                            {unique.includes(concourseGroup.concourseGroupsCode) &&
                                <Flex style={{color: "red"}}>
                                    пересечение
                                </Flex>}
                            <Button
                                type={"text"}
                                icon={<FaLongArrowAltDown size={16} color={"#1677ff"}/>}
                                onClick={() => changePriority(concourseGroup, false)}
                            />
                            <Flex style={{
                                fontWeight: "bold",
                                fontSize: "16px"
                            }}>{result.concourseGroupsPriority.find(group => group.code === concourseGroup.concourseGroupsCode)?.priority}</Flex>
                            <Button
                                type={"text"}
                                icon={<FaLongArrowAltUp size={16} color={"#1677ff"}/>}
                                onClick={() => changePriority(concourseGroup, true)}
                            />
                        </Flex>
                    </Flex>
                </Flex>
                {concourseGroup.profiles.length > 0 &&
                    <>
                        <div style={{backgroundColor: "lightgray", width: "100%", height: "1px"}}></div>
                        <Flex
                            style={{padding: "8px 16px"}}
                            vertical={true}
                            justify={"center"}
                            align={"center"}
                            gap={8}>
                            {concourseGroup.profiles.map((profile, index) => (
                                <Flex justify={"space-between"} align={"center"} style={{width: '100%'}} key={index}>
                                    <div>{profile.name}</div>
                                    <Flex align={"center"} gap={8} justify={"center"}>
                                        {uniqueProfiles.get(concourseGroup.concourseGroupsCode)?.includes(profile.code) &&
                                            <Flex style={{color: "red"}}>
                                                пересечение
                                            </Flex>}
                                        <Button
                                            type={"text"}
                                            icon={<FaLongArrowAltDown size={16} color={"#1677ff"}/>}
                                            onClick={() => changeProfilePriority(concourseGroup, profile, false)}
                                        />
                                        <Flex style={{
                                            fontWeight: "bold",
                                            fontSize: "16px"
                                        }}>{getProfilePriorityText(concourseGroup, profile)}</Flex>
                                        <Button
                                            type={"text"}
                                            icon={<FaLongArrowAltUp size={16} color={"#1677ff"}/>}
                                            onClick={() => changeProfilePriority(concourseGroup, profile, true)}
                                        />
                                    </Flex>
                                </Flex>
                            ))}
                        </Flex>
                    </>
                }
            </Flex>
        )
    }

    return (
        <Flex align={"center"} justify={xl ? "center" : "flex-start"} style={{width: '100%', height: '100%'}} gap={16}
              vertical={true}>
            <Flex vertical={true} justify={xl ? "center" : "flex-start"} align={"center"} gap={16}>
                <Typography.Text style={{fontSize: xl ? "20px" : "16px", paddingBottom: xl ? "24px" : ""}}
                                 strong={true}>Расставьте приоритеты у
                    выбранных
                    специальностей</Typography.Text>
                <Row gutter={[16, 16]} justify={"center"}>
                    {selectedGroups.map((value, index, array) => {
                        return <Col key={index}><ConcourseCard key={index} concourseGroup={value}/></Col>
                    })}
                </Row>
            </Flex>
        </Flex>
    )
}